import React, {
  useEffect,
  useState,
} from "react";

const StudentCouncil = () => {

  const [data, setData] =
    useState([]);

  // FETCH DATA
  useEffect(() => {

    fetch(
      "https://stjosephweb.ilakshyaerp.in/api/student-council/all"
    )
      .then((res) => res.json())
      .then((res) =>
        setData(
          Array.isArray(res)
            ? res
            : []
        )
      );

  }, []);

  return (

    <section className="w-full bg-[#F5F4DF] min-h-screen py-10">

      <div className="max-w-6xl mx-auto px-4">

        {/* DATA */}
        {
          data.length > 0
            ? (
              data.map(
                (item) => (

                  <div
                    key={item.id}
                    className="mb-12 border-[3px] border-[#F59E0B] bg-white shadow-lg overflow-hidden"
                  >

                    {/* TITLE */}
                    <div className="bg-[#FCD58A] border-b-[3px] border-[#F59E0B]">

                      <h2 className="text-center text-2xl md:text-4xl font-bold text-[#072F5F] py-4 uppercase">

                        {item.title}

                      </h2>

                    </div>

                    {/* FILE */}
                    <div className="p-3 md:p-5">

                      {
                        item.type ===
                        "image"
                          ? (

                            <img
                              src={`https://stjosephweb.ilakshyaerp.in/uploads/student-council/${item.file}`}
                              alt="student council"
                              className="w-full rounded-lg border-2 border-[#F59E0B]"
                            />

                          )
                          : (

                            <iframe
                              src={`https://stjosephweb.ilakshyaerp.in/uploads/student-council/${item.file}`}
                              title="student-council"
                              className="w-full h-[900px] border-2 border-[#F59E0B]"
                            />

                          )
                      }

                    </div>

                  </div>
                )
              )
            )
            : (

              <div className="text-center py-24">

                <h2 className="text-4xl font-bold text-[#072F5F]">

                  No Student Council Data Available

                </h2>

              </div>
            )
        }

      </div>

    </section>
  );
};

export default StudentCouncil;